import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TriangleUpIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M11.5 9L7 14L16 14L11.5 9Z'
                fill='currentColor'
            />
        </>
    ),
})

TriangleUpIcon.displayName = 'TriangleUpIcon'
